import { render, staticRenderFns } from "./FederalId.vue?vue&type=template&id=42031d1d"
import script from "./FederalId.vue?vue&type=script&lang=js"
export * from "./FederalId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports